import { Alert, AlertDescription } from '@up2stay/up2promo-ui';
import { shellPaths } from '@/core/router/app-paths';

import { ShellLink } from '@/core/components/navigation/shell-link';
import type { LinkedProductSummary } from '@/core/hooks/use-location-linked-products';

type LinkedProductsDict = {
  banner?: string;
  viewProducts?: string;
};

export function LocationLinkedProductsBanner({
  linkedProducts,
  locationId,
  dict,
}: {
  linkedProducts: LinkedProductSummary[];
  locationId: string;
  dict?: LinkedProductsDict;
}) {
  if (linkedProducts.length === 0) return null;

  const bannerText =
    dict?.banner?.replace('{count}', String(linkedProducts.length)) ??
    `${linkedProducts.length} product(s) use this location for redirects.`;

  return (
    <Alert variant="default" className="border-border/60 bg-muted/30">
      <AlertDescription className="flex flex-col gap-2 text-sm text-muted-foreground sm:flex-row sm:items-center sm:justify-between">
        <span>{bannerText}</span>
        <ShellLink
          to={`${shellPaths.moreProducts}?locationId=${encodeURIComponent(locationId)}`}
          className="shrink-0 font-medium text-foreground underline-offset-4 hover:underline"
        >
          {dict?.viewProducts ?? 'View products'}
        </ShellLink>
      </AlertDescription>
    </Alert>
  );
}
